import { Injectable, Injector } from '@angular/core';
import { InjectableByKey } from '@common-modules/shared/injectable-by-key/injectable-by-key.decorator';
import { PagedResultDto } from '@common-modules/shared/model/paged-result.dto';
import { GridODataService } from '@common-modules/shared/odata/grid-odata.service';
import { IActivityConfirmationDto } from '../shared/model/alc/activity-confirmation.dto';

@InjectableByKey({ key: 'ActivityConfirmationService' })
@Injectable({ providedIn: 'root' })
export class ActivityConfirmationService extends GridODataService<IActivityConfirmationDto> {
  constructor(injector: Injector) {
    super(injector, '/api/alc/wo/confirmation');
  }

  protected mapResponse(
    response: PagedResultDto<IActivityConfirmationDto>
  ): PagedResultDto<IActivityConfirmationDto> {
    return response;
  }
}
